/**
 * PHARMAKON — Fournisseur ERP · NotificationBell (Module 00, Appendix E.9)
 *
 * Topbar bell with an unread badge; opens the NotificationDrawer. Reads the
 * per-staff feed store (no prop-drilling). Composed from ERP V3 primitives.
 */
import * as React from "react";
import { IconButton } from "@/components/ui/primitives";
import { useFournisseurNotifStore } from "@/stores/fournisseur/fournisseurNotifStore.js";

export default function NotificationBell() {
  const unread = useFournisseurNotifStore((s) => s.unread);
  const openDrawer = useFournisseurNotifStore((s) => s.openDrawer);

  return (
    <div className="relative">
      <IconButton icon="bell" label="Notifications" onClick={openDrawer} />
      {unread > 0 && (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute -top-0.5 -right-0.5 min-w-[17px] h-[17px] rounded-full bg-danger text-white text-[10px] font-mono font-bold flex items-center justify-center px-1 ring-2 ring-bg-elevated"
        >
          {unread > 99 ? "99+" : unread}
        </span>
      )}
    </div>
  );
}
